var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("Политика сервисного обслуживания dormakaba")]),_c('p',[_vm._v("Текст политики сервисного обслуживания dormakaba")]),_c('home-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }